import React from "react";
import "./Loans.css";

const loanData = [
  {
    title: "Home Loan",
    text:
      "A home loan is a financial facility provided by banks or financial institutions to help individuals purchase, construct, or renovate a house or flat. The borrower repays the loan in affordable monthly installments (EMIs) over a fixed tenure, making home ownership easier and more accessible. Home loans also offer attractive interest rates and tax benefits as per applicable laws.",
    icon: "/icons/z15.png"
  },
  {
    title: "Personal Loan",
    text:
      "A personal loan is an unsecured loan provided by banks or financial institutions to meet personal financial needs such as medical expenses, education, travel, home renovation, or emergencies. It does not require any collateral and is repaid through fixed monthly installments (EMIs) over a chosen tenure, offering quick and flexible financial support.",
    icon: "/icons/z14.png"
  },
  {
    title: "Auto Loan",
    text:
      "An auto loan is a financial facility offered by banks or financial institutions to help individuals purchase a new or used car or two-wheeler. The borrower repays the loan through affordable monthly installments (EMIs) over a fixed tenure, making vehicle ownership easy and convenient. Auto loans typically come with flexible repayment options and competitive interest rates.",
    icon: "/icons/z11.png"
  },
    {
    title: "Commercial Loan",
    text:
      "A commercial loan is a financial facility provided by banks or financial institutions to support business needs such as expansion, working capital, equipment purchase, infrastructure development, or commercial property acquisition. The loan is repaid through structured installments based on the agreed tenure and helps businesses grow while maintaining cash flow.",
    icon: "/icons/z19.png"
  }
];

export default function Loans() {
  return (
    <section className="loans-section" id="loans">
      <h2 className="loans-heading">Loans</h2>

      <div className="loans-grid">
        {loanData.map((item, index) => (
          <div className="loans-card" key={index}>
            <img src={item.icon} alt={item.title} className="card-icon" />
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
